const utmServices = {
  utmRead() {
    const utm = window.localStorage.getItem('utm')
    if (utm) return JSON.parse(utm)
    return null
  }
}

export default utmServices
